export const EDIT_MY_CLASSIFIED_AD_MUTATION = require('./editMyClassifiedAdMutation.graphql');
export const REQUEST_OFFER_PRICE = require('./requestPriceMutation.graphql');
export const PLACE_AN_AD = require('./placeAnAdMutation.graphql');
export const PLACE_AN_AD_UPDATE_PAYMENT_MUTATION = require('./placeAnAdUpdatePaymentMutation.graphql');
